(() => {
  const tabs = [...document.querySelectorAll("[data-whf-tab]")];
  if (!tabs.length) return;
  const sections = tabs.map((t) => document.querySelector(t.getAttribute("href")));
  let suppressUntil = 0;

  tabs.forEach((tab) => {
    tab.addEventListener("click", (e) => {
      e.preventDefault();
      const target = document.querySelector(tab.getAttribute("href"));
      suppressUntil = Date.now() + 900;
      tabs.forEach((t) => t.classList.toggle("is-active", t === tab));
      if (!target) return;
      const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      target.scrollIntoView({ behavior: reduce ? "auto" : "smooth", block: "start" });
    });
  });

  const observer = new IntersectionObserver(
    (entries) => {
      if (Date.now() < suppressUntil) return;
      const visible = entries.filter((e) => e.isIntersecting);
      if (!visible.length) return;
      const activeSection = visible[visible.length - 1].target;
      const idx = sections.indexOf(activeSection);
      if (idx === -1) return;
      tabs.forEach((t, i) => t.classList.toggle("is-active", i === idx));
    },
    { rootMargin: "-152px 0px -60% 0px" }
  );
  sections.forEach((s) => s && observer.observe(s));
})();

// Pin the tab bar with position:fixed. CSS `position: sticky` cannot work here:
// each Shopify section renders its own `.whf` wrapper, so the nav's sticky
// containing block is that ~45px wrapper, not the page. The resting offset is
// measured from the real site header (itself sticky, 166px unscrolled / 96px
// scrolled) rather than assumed.
(() => {
  const wrap = document.querySelector("[data-whf-tabs-wrap]");
  const nav = wrap && wrap.querySelector("[data-whf-tabs]");
  if (!nav) return;
  const header = document.querySelector(".site-header--sticky, .site-header-wrapper");
  let queued = false;

  const headerBottom = () => {
    if (!header) return 0;
    const r = header.getBoundingClientRect();
    return r.height > 0 ? Math.max(0, r.bottom) : 0;
  };

  const unpin = () => {
    wrap.classList.remove("is-fixed");
    wrap.style.height = "";
    nav.style.top = nav.style.left = nav.style.width = "";
  };

  const update = () => {
    queued = false;
    const offset = headerBottom();
    // Anchor targets must clear the header AND the pinned bar, and both differ
    // between viewports and header states, so publish the measured value.
    document.documentElement.style.setProperty(
      "--whf-anchor-offset",
      Math.round(offset + nav.getBoundingClientRect().height + 8) + "px"
    );
    if (wrap.classList.contains("is-fixed")) {
      // wrap keeps the nav's place in flow, so its own top is the unpin point.
      if (wrap.getBoundingClientRect().top >= offset) return unpin();
    } else {
      if (nav.getBoundingClientRect().top >= offset) return;
      wrap.style.height = nav.getBoundingClientRect().height + "px";
      wrap.classList.add("is-fixed");
    }
    const r = wrap.getBoundingClientRect();
    nav.style.top = offset + "px";
    nav.style.left = r.left + "px";
    nav.style.width = r.width + "px";
  };

  const schedule = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(update);
  };

  addEventListener("scroll", schedule, { passive: true });
  addEventListener("resize", () => { unpin(); schedule(); });
  schedule();
})();

(() => {
  document.querySelectorAll("[data-whf-video]").forEach((el) => {
    el.querySelector(".whf-video-play")?.addEventListener("click", () => {
      const id = el.dataset.youtubeId;
      if (!id) return;
      el.innerHTML = `<iframe src="https://www.youtube-nocookie.com/embed/${id}?autoplay=1" title="Install video" allow="autoplay; encrypted-media" allowfullscreen style="width:100%;height:100%;border:0"></iframe>`;
    });
  });
})();
